// extracted by mini-css-extract-plugin
module.exports = {"payment":"Payment_payment__mJHLB"};